import * as React from "react";
import {useEffect, useState} from "react";
import {SliderControlComponent} from "../../form/sliderControl.component";
import {useLeadStore} from "../store/Lead.store";
import {observer} from "mobx-react-lite";
import {BoxFieldListControlComponent} from "../../form/boxFieldListControl.component";
import {ButtonComponent} from "../../form/button.component";
import './order-step.scss';
import {LoadingComponent} from "../components/loading.component";
import {BelfiusBlock} from "../components/belfius-block.component";
import useBelfiusTheme from "../theme/ThemeHooks";

const CalculationOverview = observer( () => {
    const store = useLeadStore();

    return (<div className={"mt-3 position-relative"}>
        <LoadingComponent show={store.quoteSimulation.reloading}/>
        <span className={"font-weight-bold"}>{store.translate( 'leadgeneration.steps.order.calculation' )}</span>

        <div className={"price-list w-100 p-3"}>
            <div className={"row mb-2 d-flex justify-content-between"}>
                <div>{store.translate( 'leadgeneration.steps.order.basePrice' )}</div>
                <div>€ {store.quoteSimulation.basePrice}</div>
            </div>
            <div className={"row mb-2 d-flex justify-content-between"}>
                <div>{store.translate( 'leadgeneration.steps.order.vat' )} {store.quoteSimulation.vatPercentage}%</div>
                <div>€ {store.quoteSimulation.vat}</div>
            </div>
            <div className={"row mb-2 d-flex justify-content-between"}>
                <div>{store.translate( 'leadgeneration.steps.order.greenTax' )}</div>
                <div>€ {store.quoteSimulation.greenTax}</div>
            </div>
            <div className={"row price-line"}/>
            <div className={"row mb-2 d-flex justify-content-between font-weight-bold"}>
                <div>{store.translate( 'leadgeneration.steps.order.total' )}</div>
                <div>€ {store.quoteSimulation.total}</div>
            </div>
        </div>
    </div>)
} );

export const OrderStep = observer( () => {
    const store = useLeadStore();
    const [downloadButtonDisabled, setDownloadButtonDisabled] = useState( false );
    let {themeClassName} = useBelfiusTheme();

    useEffect( () => {
        if ( store && store.options.panel ) {
            store.doSimulation()
        }
    }, [store, store.options.panel] );

    useEffect( () => {
        if ( store.quotePdfGeneration.blobUrl !== null ) {
            console.log( store.quotePdfGeneration.blobUrl );
        }
    }, [store, store.quotePdfGeneration.blobUrl] );

    useEffect( () => {
        if ( store ) {
            setDownloadButtonDisabled( store.quotePdfGeneration.generationState === "Generating" );
        }
    }, [store, store.quotePdfGeneration.generationState] );

    const downloadQuote = () => {
        store.startPdfGeneration();
    }

    const completeOrder = () => {
        store.sendConfirmationMail();
        store.updateLead().then( () => {
            store.goToNextStep();
        } )
    };

    const getBoxFieldOptions = ( totalNumberOfBatteries ) => {
        let options = [];

        for ( let i = 0; i <= totalNumberOfBatteries; i++ ) {
            options.push( {text: i, value: i} );
        }

        return options;
    };

    if ( !store.options.panel ) {
        return <React.Fragment/>
    }

    return (<div className={"row"}>
        <div className={"col-md-6"}>
            <div className={"font-weight-bold mb-2"}>{store.translate( 'leadgeneration.steps.order.solarPanels' )}</div>
            { store.quoteSimulation.invalidPanelCount &&
                    <div className={"text-danger mb-2"}>{store.options.panel.packageNotFoundMessage}</div>
            }
            <SliderControlComponent
                    name={"solarAmount"}
                    currentValue={store.quote.solarQuantity}
                    min={store.options.panel.min}
                    max={store.options.panel.max}
                    theme={themeClassName}
                    onChange={( event ) => {
                        store.setSolarQuantity( event.target.valueAsNumber );
                    }}/>

            <div className={"font-weight-bold mb-2"}>{store.translate( 'leadgeneration.steps.order.batteries' )}</div>
            <BoxFieldListControlComponent
                    name={"batteryQuantity"}
                    options={getBoxFieldOptions( 4 )}
                    theme={themeClassName}
                    onChange={( value ) => {
                        store.setBatteryQuantity( value );
                    }}
                    value={store.quote.batteryQuantity}/>

            <CalculationOverview/>
        </div>
        <div className={"col-md-6 position-relative"}>
            <LoadingComponent show={store.quoteSimulation.reloading}/>
            <h3>{store.translate( 'leadgeneration.steps.order.informationTextTitle' )}</h3>

            <p>{store.quoteSimulation.suggestionPack}</p>

            <div className="text" dangerouslySetInnerHTML={{__html: store.translate( 'leadgeneration.steps.order.informationText' )}}/>

            <div className={"button-row mt-3 d-flex justify-content-between"}>
                <ButtonComponent text={store.translate( 'leadgeneration.steps.order.nextButton' )}
                                 onClick={() => {
                                     completeOrder();
                                 }}
                                 type={'primary'}
                                 disabled={store.quoteSimulation.invalidPanelCount}
                                 theme={themeClassName}
                                 additionalCssClasses={['w-100']}/>
                <LoadingComponent show={store.quotePdfGeneration.generationState === "generationState" && store.quotePdfGeneration.pdfIdentifier !== null}/>
                <ButtonComponent disabled={downloadButtonDisabled || store.quoteSimulation.invalidPanelCount}
                                 text={store.translate( 'leadgeneration.steps.order.downloadButton' )}
                                 theme={themeClassName}
                                 onClick={() => {
                                     downloadQuote();
                                 }}
                                 additionalCssClasses={['w-100', 'leadgeneration-download-simulation']}
                                 type={'primary'}/>
            </div>
        </div>
        <div className={"col-md-12 ml-3"}>
            { !store.quoteSimulation.invalidPanelCount &&
                    <BelfiusBlock/>
            }
        </div>
    </div>)
} );
